import Vue from 'vue'
import Vuex from 'vuex'

import {
  adminChangePassword,
  updateAdmin,
  getAdmin,
  getAdminMarket,
  updateMarketSettings,
  marketLogo,
  createMarketImage,
  deleteMarketImage,
  getCustomerList,
  getAllCustomers,
  getCustomer,
  editCustomer,
  addCustomer,
  deleteCustomer,
  sendEmailConfirmation,
  resetCustomerPassword,
  verifyCustomer,
  getPaymentsInfo,
  getCustomerPaymentReports,
  getShelfList,
  editShelf,
  addShelf,
  deleteShelf,
  getBookingPeriodList,
  editBookingPeriod,
  addBookingPeriod,
  deleteBookingPeriod,
  getAdditionalServiceList,
  editAdditionalService,
  addAdditionalService,
  deleteAdditionalService,
  getShelfTypeList,
  editShelfType,
  addShelfType,
  deleteShelfType,
  getShelfPeriodPriceList,
  updateShelfPeriodPrice,
  getShelfTypeServiceList,
  updateShelfTypeService,
  updateMarketClosingDays,
  bookingRequests,
  getCampaignList,
  editCampaign,
  addCampaign,
  deleteCampaign,
  getShelfBookingList,
  editShelfBooking,
  addShelfBooking,
  deleteShelfBooking,
  getCustomerBookings,
  salesPeriods,
  bankExportTransactions,
  economicLayouts,
  marketMessages,
  bookingsReport,
  customerCampaignsReport,
  getCustomerProductSalesReport,
  getBookingTransactionReport,
  customerProductSheets,
  createCustomerProductSheet,
  updateCustomerProductSheet,
  deleteCustomerProductSheet,
  getCustomerProducts,
  productsUpdate,
  createCustomerProduct,
  productCampaigns,
  getCustomerProductSaleLines,
  balanceTransactions,
  customerSubaccounts,
  getCustomerBalanceReport,
  exportCustomerBalanceReportPdf,
  exportCustomerBalanceReportXlsx,
  getManualTransactionsReport,
  getSoloProductList,
  addSoloProduct,
  editSoloProduct,
  deleteSoloProduct,
  reorderSoloProducts,
  getSoloCategoryList,
  addSoloCategory,
  editSoloCategory,
  deleteSoloCategory,
  reorderSoloCategories,
  getSoloSaleList,
  getSoloSale,
  createSoloSale,
  refundSoloSale,
  lookupSoloProduct,
  emailSoloReceipt,
  downloadSoloReceiptPdf,
  getSoloReceiptHtml,
  getSoloSaleTotals,
  downloadSoloCsv,
} from '@admin/services'

import {
  baseActions,
  baseGetters,
  baseMutations,
  baseState,
  adminRequestInterceptor,
  cleanStorages,
  adminResponseFulfilledInterceptor,
  adminResponseRejectedInterceptor,
  getToken,
  setToken,
} from '@base/store'

import { actionTypes, mutationTypes } from '@base/store/store-types'
import { BOOKING_REFUND_INITIATED, webConfig } from '@base/configs'
import { revokeToken } from '@base/services'
import i18n from '@base/i18n'
import { floatToLocalizedString, localizedStringToNumber } from '@base/utils'

Vue.use(Vuex)

const initialState = {
  ...baseState,
  adminMarket: null,
  customer: null,
  customerList: [],
  allCustomers: [],
  customerArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  paymentsInfo: [],
  paymentsInfoArg: {
    filters: null
  },
  savedPeriods: [],
  finalizedSavedPeriods: [],
  shelfList: [],
  shelfArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  shelfPeriodPriceList: [],
  shelfTypeServiceList: [],
  bookingPeriodList: [],
  bookingPeriodArg: {
    filters: null
  },
  additionalServiceList: [],
  additionalServiceArg: {
    filters: null
  },
  shelfTypeList: [],
  shelfTypeArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  bookingRequestList: [],
  bookingRequestArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  customerPaymentReports: [],
  customerPaymentReportsArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  customerProductSalesTotals: {},
  customerProductSales: [],
  customerProductSalesArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  customerBookingTransactionsTotals: {},
  customerBookingTransactions: [],
  customerBookingTransactionsArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  campaignList: [],
  campaignArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  availableShelfIds: [],
  bookingRequestDates: {},
  selectedBookingRequest: null,
  shelfBookingList: [],
  shelfBookingArg: {
    filters: null
  },
  customerBookingList: [],
  customerBookingArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  selectedCustomerProductSheet: null,
  customerProductSaleLines: [],
  customerProductSheets: [],
  customerProductSheetsArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  customerBalanceTransactions: [],
  customerBalanceTransactionsArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  customerProducts: [],
  customerProductsArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  saveType: null,
  bankExportTransactions: [],
  bankExportTransactionsArg: {
    filters: null
  },
  economicLayouts: [],
  marketMessages: [],
  marketMessagesArg: {
    page: 1,
    pagesCount: 0,
    filters: null
  },
  unseenMessagesNumber: 0,
  pendingBookingRequests: 0,
  adminNavItems: [],
  bookingsReport: [],
  bookingsReportArg: {
    filters: null
  },
  customerCampaignsReport: [],
  customerCampaignsReportArg: {
    page: 1,
    pagesCount: 0,
    filters: null,
  },
  customerBalanceReportList: [],
  customerBalanceReportArg: {
    page: 1,
    pagesCount: 0,
    totalBalance: '0.00',
    filters: null,
  },
  manualTransactionsReport: [],
  manualTransactionsReportArg: {
    page: 1,
    pagesCount: 0,
    filters: null,
  },
  soloProductList: [],
  soloProductArg: {
    page: 1,
    pagesCount: 0,
    filters: null,
  },
  soloCategoryList: [],
  soloSaleList: [],
  soloSaleArg: {
    page: 1,
    pagesCount: 0,
    filters: null,
  },
  selectedSoloSale: null,
}

const axiosInstances = [
  adminChangePassword,
  updateAdmin,
  getAdmin,
  getAdminMarket,
  updateMarketSettings,
  marketLogo,
  createMarketImage,
  deleteMarketImage,
  getCustomerList,
  getAllCustomers,
  getCustomer,
  editCustomer,
  addCustomer,
  deleteCustomer,
  sendEmailConfirmation,
  resetCustomerPassword,
  verifyCustomer,
  getPaymentsInfo,
  getCampaignList,
  editCampaign,
  addCampaign,
  deleteCampaign,
  getShelfList,
  editShelf,
  addShelf,
  deleteShelf,
  getBookingPeriodList,
  editBookingPeriod,
  addBookingPeriod,
  deleteBookingPeriod,
  getAdditionalServiceList,
  editAdditionalService,
  addAdditionalService,
  deleteAdditionalService,
  getShelfTypeList,
  editShelfType,
  addShelfType,
  deleteShelfType,
  getShelfPeriodPriceList,
  updateShelfPeriodPrice,
  getShelfTypeServiceList,
  updateShelfTypeService,
  updateMarketClosingDays,
  bookingRequests,
  getShelfBookingList,
  editShelfBooking,
  addShelfBooking,
  deleteShelfBooking,
  getCustomerBookings,
  salesPeriods,
  getCustomerPaymentReports,
  bankExportTransactions,
  economicLayouts,
  marketMessages,
  bookingsReport,
  customerCampaignsReport,
  getCustomerProductSalesReport,
  getBookingTransactionReport,
  customerProductSheets,
  createCustomerProductSheet,
  updateCustomerProductSheet,
  deleteCustomerProductSheet,
  getCustomerProducts,
  productsUpdate,
  createCustomerProduct,
  productCampaigns,
  getCustomerProductSaleLines,
  balanceTransactions,
  customerSubaccounts,
  getCustomerBalanceReport,
  exportCustomerBalanceReportPdf,
  exportCustomerBalanceReportXlsx,
  getManualTransactionsReport,
  getSoloProductList,
  addSoloProduct,
  editSoloProduct,
  deleteSoloProduct,
  reorderSoloProducts,
  getSoloCategoryList,
  addSoloCategory,
  editSoloCategory,
  deleteSoloCategory,
  reorderSoloCategories,
  getSoloSaleList,
  getSoloSale,
  createSoloSale,
  refundSoloSale,
  lookupSoloProduct,
  emailSoloReceipt,
  downloadSoloReceiptPdf,
  getSoloReceiptHtml,
  getSoloSaleTotals,
  downloadSoloCsv,
]

for (const instance of axiosInstances) {
  instance.interceptors.request.use(adminRequestInterceptor)
  instance.interceptors.response.use(
    adminResponseFulfilledInterceptor,
    adminResponseRejectedInterceptor
  )
}


document.initialState = initialState      // Needs to be in each section stores for base auth user behavior

export default new Vuex.Store({
  state: initialState,
  getters: {
    ...baseGetters,

    getCustomerPage: state => state.customerArg.page,
    getCustomerPagesCount: state => state.customerArg.pagesCount,

    getShelfPage: state => state.shelfArg.page,
    getShelfPagesCount: state => state.shelfArg.pagesCount,

    getShelfTypePage: state => state.shelfTypeArg.page,
    getShelfTypePagesCount: state => state.shelfTypeArg.pagesCount,

    getBookingRequestPage: state => state.bookingRequestArg.page,
    getBookingRequestPagesCount: state => state.bookingRequestArg.pagesCount,

    getCustomerPaymentReportPage: state => state.customerPaymentReportsArg.page,
    getCustomerPaymentReportPagesCount: state => state.customerPaymentReportsArg.pagesCount,

    getCustomerProductSalePage: state => state.customerProductSalesArg.page,
    getCustomerProductSalePagesCount: state => state.customerProductSalesArg.pagesCount,

    getCustomerBookingTransactionPage: state => state.customerBookingTransactionsArg.page,
    getCustomerBookingTransactionPagesCount: state => state.customerBookingTransactionsArg.pagesCount,

    getCampaignPage: state => state.campaignArg.page,
    getCampaignPagesCount: state => state.campaignArg.pagesCount,

    getCustomerProductsPage: state => state.customerProductsArg.page,
    getCustomerProductsPagesCount: state => state.customerProductsArg.pagesCount,

    getCustomerBookingPage: state => state.customerBookingArg.page,
    getCustomerBookingPagesCount: state => state.customerBookingArg.pagesCount,

    getCustomerProductSheetPage: state => state.customerProductSheetsArg.page,
    getCustomerProductSheetPagesCount: state => state.customerProductSheetsArg.pagesCount,

    getMarketMessagesPage: state => state.marketMessagesArg.page,
    getMarketMessagesPagesCount: state => state.marketMessagesArg.pagesCount,

    getCustomerCampaignsReportPage: state => state.customerCampaignsReportArg.page,
    getCustomerCampaignsReportPagesCount: state => state.customerCampaignsReportArg.pagesCount,

    getCustomerBalanceTransactionsPage: state => state.customerBalanceTransactionsArg.page,
    getCustomerBalanceTransactionsPagesCount: state => state.customerBalanceTransactionsArg.pagesCount,

    getCustomerBalanceReportPage: state => state.customerBalanceReportArg.page,
    getCustomerBalanceReportPagesCount: state => state.customerBalanceReportArg.pagesCount,
    getCustomerBalanceReportTotalBalance: state => state.customerBalanceReportArg.totalBalance,

    getManualTransactionsReportPage: state => state.manualTransactionsReportArg.page,
    getManualTransactionsReportPagesCount: state => state.manualTransactionsReportArg.pagesCount,

    getSoloProductPage: state => state.soloProductArg.page,
    getSoloProductPagesCount: state => state.soloProductArg.pagesCount,

    getSoloSalePage: state => state.soloSaleArg.page,
    getSoloSalePagesCount: state => state.soloSaleArg.pagesCount,

  },
  mutations: {
    ...baseMutations,

    // eslint-disable-next-line no-unused-vars
    [mutationTypes.LOGOUT_ADMIN](state, url) {
      state = document.initialState
      cleanStorages('AdminToken')
      document.location = url ? url : webConfig.baseURL
    },
    [mutationTypes.SET_ADMIN_MARKET](state, market) {
      state.adminMarket = market
    },
    [mutationTypes.SET_MARKET_SETTINGS](state, market) {
      state.adminMarket = market
    },
    [mutationTypes.UPDATE_MARKET_LOGO](state, data) {
      state.adminMarket = {
        ...state.adminMarket,
        logo: data.logo
      }
    },
    [mutationTypes.DELETE_MARKET_LOGO](state) {
      state.adminMarket = {
        ...state.adminMarket,
        logo: null
      }
    },
    [mutationTypes.APPEND_MARKET_IMAGE](state, newImage) {
      state.adminMarket.marketImages.push(newImage)
    },
    [mutationTypes.DELETE_MARKET_IMAGE](state, imageId) {
      const oldImage = state.adminMarket.marketImages.findIndex(
        obj => obj.id === imageId
      )
      state.adminMarket.marketImages.splice(oldImage, 1)
    },

    [mutationTypes.SET_CUSTOMER_LIST](state, customers) {
      state.customerList = customers
    },
    [mutationTypes.SET_ALL_CUSTOMERS](state, customers) {
      state.allCustomers = customers
    },
    [mutationTypes.SET_CUSTOMER](state, customer) {
      state.customer = customer
    },
    [mutationTypes.SET_CUSTOMER_PAGE] (state, page) {
      state.customerArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_FILTERS] (state, filters) {
      state.customerArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_PAGES_COUNT] (state, count) {
      state.customerArg.pagesCount = count
    },
    [mutationTypes.APPEND_CUSTOMER](state, customer) {
      state.customerList.unshift(customer)
    },
    [mutationTypes.DELETE_CUSTOMER](state, userNumber) {
      const oldCustomerIndex = state.customerList.findIndex(customer => customer.userNumber === userNumber)
      if (oldCustomerIndex >= 0)
        state.customerList.splice(oldCustomerIndex, 1)
    },
    [mutationTypes.UPDATE_CUSTOMER](state, { oldUserNumber, customer }) {
      const oldCustomerObj = state.customerList.find(obj => obj.userNumber === oldUserNumber)
      if (oldCustomerObj)
        Object.assign(oldCustomerObj, customer)
    },
    [mutationTypes.UPDATE_CUSTOMER_SUBACCOUNT](state, subaccount) {
      const parentCustomer = state.customerList.find(
        customer => customer.id === subaccount.parentAccount
      )

      if (parentCustomer && parentCustomer.subaccounts) {
        const oldSubaccountIndex = parentCustomer.subaccounts.findIndex(obj => obj.userNumber === subaccount.userNumber)
        if (oldSubaccountIndex >= 0)
          parentCustomer.subaccounts.splice(oldSubaccountIndex, 1, subaccount)
        }
    },
    [mutationTypes.VERIFY_CUSTOMER] (state, { userNumber, verified }) {
      const customerObj = state.customerList.find(obj => obj.userNumber === userNumber)
      customerObj.verified = verified
    },
    [mutationTypes.SET_PAYMENTS_INFO](state, paymentsInfo) {
      state.paymentsInfo = paymentsInfo
    },
    [mutationTypes.SET_FINALIZED_SAVED_PERIODS](state, periods) {
      state.finalizedSavedPeriods = periods
    },
    [mutationTypes.SET_SAVED_PERIODS](state, savedPeriods) {
      state.savedPeriods = savedPeriods
    },
    [mutationTypes.DELETE_SAVED_PERIOD](state, id) {
      const oldSavedPeriodIndex = state.savedPeriods.findIndex(shelf => shelf.id === id)
      if (oldSavedPeriodIndex >= 0)
        state.savedPeriods.splice(oldSavedPeriodIndex, 1)
    },
    [mutationTypes.UPDATE_SALES_PERIOD](state, { id, period }) {
      const salesPeriodObj = state.savedPeriods.find(obj => obj.id === id)
      Object.assign(salesPeriodObj, period)
    },
    [mutationTypes.SET_CUSTOMER_PAYMENT_REPORTS](state, reports) {
      state.customerPaymentReports = reports
    },
    [mutationTypes.SET_CUSTOMER_PAYMENT_REPORTS_FILTERS] (state, filters) {
      state.customerPaymentReportsArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_PAYMENT_REPORTS_PAGE] (state, page) {
      state.customerPaymentReportsArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_PAYMENT_REPORTS_PAGES_COUNT] (state, count) {
      state.customerPaymentReportsArg.pagesCount = count
    },
    [mutationTypes.SET_SALE_LINES_FILTERS] (state, filters) {
      state.paymentsInfoArg.filters = filters
    },
    [mutationTypes.SET_SHELF_LIST](state, shelves) {
      state.shelfList = shelves
    },
    [mutationTypes.SET_SHELF_FILTERS] (state, filters) {
      state.shelfArg.filters = filters
    },
    [mutationTypes.SET_SHELF_PAGE] (state, page) {
      state.shelfArg.page = page
    },
    [mutationTypes.SET_SHELF_PAGES_COUNT] (state, count) {
      state.shelfArg.pagesCount = count
    },
    [mutationTypes.APPEND_SHELF](state, shelf) {
      state.shelfList.unshift(shelf)
    },
    [mutationTypes.DELETE_SHELF](state, id) {
      const oldShelfIndex = state.shelfList.findIndex(shelf => shelf.id === id)
      if (oldShelfIndex >= 0)
        state.shelfList.splice(oldShelfIndex, 1)
    },
    [mutationTypes.UPDATE_SHELF](state, { id, shelf }) {
      const oldShelfObj = state.shelfList.find(obj => obj.id === id)
      Object.assign(oldShelfObj, shelf)
    },
    [mutationTypes.SET_MARKET_CLOSING_DAYS](state, data) {
      state.adminMarket = {
        ...state.adminMarket,
        closingDays: data.closingDays,
        bookingOpeningDays: data.bookingOpeningDays
      }
    },
    [mutationTypes.SET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST](state, services) {
      state.shelfTypeServiceList = services
    },
    [mutationTypes.SET_SHELF_PERIOD_PRICE_LIST](state, prices) {
      state.shelfPeriodPriceList = prices
    },
    [mutationTypes.SET_BOOKING_PERIOD_LIST](state, periods) {
      state.bookingPeriodList = periods
    },
    [mutationTypes.SET_BOOKING_PERIOD_FILTERS] (state, filters) {
      state.bookingPeriodArg.filters = filters
    },
    [mutationTypes.APPEND_BOOKING_PERIOD](state, period) {
      state.bookingPeriodList.unshift(period)
    },
    [mutationTypes.DELETE_BOOKING_PERIOD](state, id) {
      const oldBookingPeriodIndex = state.bookingPeriodList.findIndex(period => period.id === id)
      if (oldBookingPeriodIndex >= 0)
        state.bookingPeriodList.splice(oldBookingPeriodIndex, 1)
    },
    [mutationTypes.UPDATE_BOOKING_PERIOD](state, { id, period }) {
      const oldBookingPeriodObj = state.bookingPeriodList.find(obj => obj.id === id)
      Object.assign(oldBookingPeriodObj, period)
    },
    [mutationTypes.SET_ADDITIONAL_SERVICE_LIST](state, periods) {
      state.additionalServiceList = periods
    },
    [mutationTypes.SET_ADDITIONAL_SERVICE_FILTERS] (state, filters) {
      state.additionalServiceArg.filters = filters
    },
    [mutationTypes.APPEND_ADDITIONAL_SERVICE](state, period) {
      state.additionalServiceList.unshift(period)
    },
    [mutationTypes.DELETE_ADDITIONAL_SERVICE](state, id) {
      const oldAdditionalServiceIndex = state.additionalServiceList.findIndex(obj => obj.id === id)
      if (oldAdditionalServiceIndex >= 0)
        state.additionalServiceList.splice(oldAdditionalServiceIndex, 1)
    },
    [mutationTypes.UPDATE_ADDITIONAL_SERVICE](state, { id, service }) {
      const oldAdditionalServiceObj = state.additionalServiceList.find(obj => obj.id === id)
      Object.assign(oldAdditionalServiceObj, service)
    },
    [mutationTypes.SET_SHELF_TYPE_LIST](state, types) {
      state.shelfTypeList = types
    },
    [mutationTypes.SET_SHELF_TYPE_FILTERS] (state, filters) {
      state.shelfTypeArg.filters = filters
    },
    [mutationTypes.SET_SHELF_TYPE_PAGE] (state, page) {
      state.shelfTypeArg.page = page
    },
    [mutationTypes.SET_SHELF_TYPE_PAGES_COUNT] (state, count) {
      state.shelfTypeArg.pagesCount = count
    },
    [mutationTypes.APPEND_SHELF_TYPE](state, type) {
      state.shelfTypeList.unshift(type)
    },
    [mutationTypes.DELETE_SHELF_TYPE](state, id) {
      const oldShelfTypeIndex = state.shelfTypeList.findIndex(type => type.id === id)
      if (oldShelfTypeIndex >= 0)
        state.shelfTypeList.splice(oldShelfTypeIndex, 1)
    },
    [mutationTypes.UPDATE_SHELF_TYPE](state, { id, type }) {
      const oldShelfTypeObj = state.shelfTypeList.find(obj => obj.id === id)
      Object.assign(oldShelfTypeObj, type)
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_REQUESTS](state, data) {
      state.bookingRequestList = data
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_REQUEST_FILTERS] (state, filters) {
      state.bookingRequestArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_REQUEST_PAGE] (state, page) {
      state.bookingRequestArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_REQUEST_PAGES_COUNT] (state, count) {
      state.bookingRequestArg.pagesCount = count
    },
    [mutationTypes.UPDATE_BOOKING_REQUEST] (state, { id, request = null, status = null, addonsRefunded = null }) {
      // For refunds backend doesn't send full BR data, we know only status and this is the only thing that changes
      const oldBookingRequestObj = state.bookingRequestList.find(obj => obj.id === id)
      if (!request) {
        if (status) {
          oldBookingRequestObj.status = status
        }
        if (addonsRefunded !== null) {
          oldBookingRequestObj.addonsRefunded = addonsRefunded
        }
        Object.assign(oldBookingRequestObj, oldBookingRequestObj)
      } else {
        Object.assign(oldBookingRequestObj, request)
      }
    },
    [mutationTypes.SET_CAMPAIGN_LIST](state, campaigns) {
      state.campaignList = campaigns
    },
    [mutationTypes.SET_CAMPAIGN_FILTERS] (state, filters) {
      state.campaignArg.filters = filters
    },
    [mutationTypes.SET_CAMPAIGN_PAGE] (state, page) {
      state.campaignArg.page = page
    },
    [mutationTypes.SET_CAMPAIGN_PAGES_COUNT] (state, count) {
      state.campaignArg.pagesCount = count
    },
    [mutationTypes.APPEND_CAMPAIGN](state, campaign) {
      state.campaignList.unshift(campaign)
    },
    [mutationTypes.DELETE_CAMPAIGN](state, id) {
      const oldCampaignIndex = state.campaignList.findIndex(shelf => shelf.id === id)
      if (oldCampaignIndex >= 0)
        state.campaignList.splice(oldCampaignIndex, 1)
    },
    [mutationTypes.UPDATE_CAMPAIGN](state, { id, campaign }) {
      const oldCampaignObj = state.campaignList.find(obj => obj.id === id)
      Object.assign(oldCampaignObj, campaign)
    },
    [mutationTypes.SET_SOLO_PRODUCT_LIST](state, products) {
      state.soloProductList = products
    },
    [mutationTypes.SET_SOLO_PRODUCT_FILTERS](state, filters) {
      state.soloProductArg.filters = filters
    },
    [mutationTypes.SET_SOLO_PRODUCT_PAGE](state, page) {
      state.soloProductArg.page = page
    },
    [mutationTypes.SET_SOLO_PRODUCT_PAGES_COUNT](state, count) {
      state.soloProductArg.pagesCount = count
    },
    [mutationTypes.APPEND_SOLO_PRODUCT](state, product) {
      state.soloProductList.unshift(product)
    },
    [mutationTypes.DELETE_SOLO_PRODUCT](state, id) {
      const oldIndex = state.soloProductList.findIndex(p => p.id === id)
      if (oldIndex >= 0)
        state.soloProductList.splice(oldIndex, 1)
    },
    [mutationTypes.UPDATE_SOLO_PRODUCT](state, { id, product }) {
      const oldProductObj = state.soloProductList.find(obj => obj.id === id)
      Object.assign(oldProductObj, product)
    },
    [mutationTypes.SET_SOLO_CATEGORY_LIST](state, categories) {
      state.soloCategoryList = categories
    },
    [mutationTypes.APPEND_SOLO_CATEGORY](state, category) {
      state.soloCategoryList.unshift(category)
    },
    [mutationTypes.UPDATE_SOLO_CATEGORY](state, { id, category }) {
      const old = state.soloCategoryList.find(obj => obj.id === id)
      if (old) Object.assign(old, category)
    },
    [mutationTypes.DELETE_SOLO_CATEGORY](state, id) {
      const idx = state.soloCategoryList.findIndex(c => c.id === id)
      if (idx >= 0) state.soloCategoryList.splice(idx, 1)
    },
    [mutationTypes.SET_SOLO_SALE_LIST](state, sales) {
      state.soloSaleList = sales
    },
    [mutationTypes.SET_SOLO_SALE_FILTERS](state, filters) {
      state.soloSaleArg.filters = filters
    },
    [mutationTypes.SET_SOLO_SALE_PAGE](state, page) {
      state.soloSaleArg.page = page
    },
    [mutationTypes.SET_SOLO_SALE_PAGES_COUNT](state, count) {
      state.soloSaleArg.pagesCount = count
    },
    [mutationTypes.SET_SELECTED_SOLO_SALE](state, sale) {
      state.selectedSoloSale = sale
    },
    [mutationTypes.APPEND_SOLO_SALE](state, sale) {
      state.soloSaleList.unshift(sale)
    },
    [mutationTypes.SET_SHELF_BOOKING_LIST](state, bookings) {
      state.shelfBookingList = bookings
    },
    [mutationTypes.SET_SHELF_BOOKING_METADATA](state, bookings) {
      state.availableShelfIds = bookings ? bookings.availableShelfIds : []
      state.bookingRequestDates = bookings ? bookings.bookingRequestDates : {}
      state.selectedBookingRequest = bookings ? bookings.bookingRequest : null
    },
    [mutationTypes.SET_SHELF_BOOKING_FILTERS] (state, filters) {
      state.shelfBookingArg.filters = filters
    },
    [mutationTypes.APPEND_SHELF_BOOKING](state, shelfBooking) {
      state.shelfBookingList.unshift(shelfBooking)
    },
    [mutationTypes.DELETE_SHELF_BOOKING](state, id) {
      const oldShelfBookingIndex = state.shelfBookingList.findIndex(shelfBooking => shelfBooking.id === id)
      if (oldShelfBookingIndex >= 0)
        state.shelfBookingList.splice(oldShelfBookingIndex, 1)
    },
    [mutationTypes.UPDATE_SHELF_BOOKING](state, { id, shelfBooking }) {
      const oldShelfBookingObj = state.shelfBookingList.find(obj => obj.id === id)
      Object.assign(oldShelfBookingObj, shelfBooking)
    },
    [mutationTypes.SET_CUSTOMER_BOOKINGS](state, bookings) {
      state.customerBookingList = bookings
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_PAGE] (state, page) {
      state.customerBookingArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_FILTERS] (state, filters) {
      state.customerBookingArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_PAGES_COUNT] (state, count) {
      state.customerBookingArg.pagesCount = count
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SHEETS](state, sheets) {
      state.customerProductSheets = sheets
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SHEETS_PAGE] (state, page) {
      state.customerProductSheetsArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SHEETS_FILTERS] (state, filters) {
      state.customerProductSheetsArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SHEETS_PAGES_COUNT] (state, count) {
      state.customerProductSheetsArg.pagesCount = count
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SHEET] (state, sheet) {
      state.selectedCustomerProductSheet = sheet
      if (sheet) {
        const token = getToken('AdminToken')
        if (token.zettleIntegration) {
          state.selectedCustomerProductSheet.products = sheet.zettleProducts
        } else if (token.isFlealoverSoloFeature) {
          state.selectedCustomerProductSheet.products = sheet.soloProducts
        } else {
          state.selectedCustomerProductSheet.products = sheet.flexposProducts
        }
      }
    },
    [mutationTypes.UPDATE_CUSTOMER_PRODUCT_SHEET](state, { id, sheet }) {
      const oldProductSheetObj = state.customerProductSheets.find(obj => obj.id === id)
      Object.assign(oldProductSheetObj, sheet)
    },
    [mutationTypes.APPEND_CUSTOMER_PRODUCT_SHEET](state, sheet) {
      state.customerProductSheets.unshift(sheet)
    },
    [mutationTypes.DELETE_CUSTOMER_PRODUCT_SHEET](state, id) {
      const oldProductSheetIndex = state.customerProductSheets.findIndex(sheet => sheet.id === id)
      if (oldProductSheetIndex >= 0)
        state.customerProductSheets.splice(oldProductSheetIndex, 1)
    },
    [mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS](state, transactions) {
      state.customerBalanceTransactions = transactions
    },
    [mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS_PAGE] (state, page) {
      state.customerBalanceTransactionsArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS_FILTERS] (state, filters) {
      state.customerBalanceTransactionsArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS_PAGES_COUNT] (state, count) {
      state.customerBalanceTransactionsArg.pagesCount = count
    },
    [mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTION](state, transaction) {
      const oldBalanceTransactionObj = state.customerBalanceTransactions.find(obj => obj.id === transaction.id)
      const oldBalanceTransactionIndex = state.customerBalanceTransactions.findIndex(obj => obj.id === transaction.id)

      if (oldBalanceTransactionIndex >= 0) {
        // Update consequent balance transactions balances on frontend
        state.customerBalanceTransactions.slice(0, oldBalanceTransactionIndex).map((tx) => {
          const balance = localizedStringToNumber(tx.balance)
          const oldAmount = localizedStringToNumber(oldBalanceTransactionObj.amount)
          const newAmount = localizedStringToNumber(transaction.amount)
          tx.balance = floatToLocalizedString(balance + newAmount - oldAmount, state.adminMarket?.supportCountry?.code)
        })
      }

      // Update the edited TX
      Object.assign(oldBalanceTransactionObj, transaction)
    },
    [mutationTypes.APPEND_CUSTOMER_BALANCE_TRANSACTION](state, transaction) {
      state.customerBalanceTransactions.unshift(transaction)
    },
    [mutationTypes.REMOVE_UPDATE_CUSTOMER_BALANCE_TRANSACTIONS](state, id) {
      const oldBalanceTransactionObj = state.customerBalanceTransactions.find(tx => tx.id === id)
      const oldBalanceTransactionIndex = state.customerBalanceTransactions.findIndex(tx => tx.id === id)
      if (oldBalanceTransactionIndex >= 0) {
        // Update consequent balance transactions balances on frontend
        state.customerBalanceTransactions.slice(0, oldBalanceTransactionIndex).map((tx) => {
          const balance = localizedStringToNumber(tx.balance)
          const amount = localizedStringToNumber(oldBalanceTransactionObj.amount)
          tx.balance = floatToLocalizedString(balance - amount, state.adminMarket?.supportCountry?.code)
        })

        // Remove deleted TX
        state.customerBalanceTransactions.splice(oldBalanceTransactionIndex, 1)
      }
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SALE_LINE_LIST] (state, lines) {
      state.customerProductSaleLines = lines
    },
    [mutationTypes.UPDATE_CUSTOMER_PRODUCT](state, { id, product }) {
      const oldProductObj = state.customerProducts.find(obj => obj.id === id)
      Object.assign(oldProductObj, product)
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_LIST] (state, products) {
      state.customerProducts = products
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_FILTERS] (state, filters) {
      state.customerProductsArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_PAGE] (state, page) {
      state.customerProductsArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_PAGES_COUNT] (state, count) {
      state.customerProductsArg.pagesCount = count
    },
    [mutationTypes.SET_SAVE_TYPE](state, saveType) {
      state.saveType = saveType
    },
    [mutationTypes.SET_BANK_EXPORT_TRANSACTIONS](state, transactions) {
      state.bankExportTransactions = transactions
    },
    [mutationTypes.SET_BANK_EXPORT_TRANSACTIONS_FILTERS] (state, filters) {
      state.bankExportTransactionsArg.filters = filters
    },
    [mutationTypes.UPDATE_BANK_EXPORT_TRANSACTION](state, transaction) {
      const oldBankExportTransactionObj = state.bankExportTransactions.find(obj => obj.id === transaction.id)
      if (oldBankExportTransactionObj)
        Object.assign(oldBankExportTransactionObj, transaction)
    },
    [mutationTypes.DELETE_BANK_EXPORT_TRANSACTION](state, id) {
      const oldObjectIndex = state.bankExportTransactions.findIndex(
        obj => obj.id === id
      )
      if (oldObjectIndex >= 0)
        state.bankExportTransactions.splice(oldObjectIndex, 1)
    },
    [mutationTypes.SET_ECONOMIC_LAYOUTS](state, layouts) {
      state.economicLayouts = layouts
    },
    [mutationTypes.SET_MARKET_MESSAGES](state, messages) {
      state.marketMessages = messages
    },
    [mutationTypes.SET_MARKET_MESSAGES_FILTERS] (state, filters) {
      state.marketMessagesArg.filters = filters
    },
    [mutationTypes.SET_MARKET_MESSAGES_PAGE] (state, page) {
      state.marketMessagesArg.page = page
    },
    [mutationTypes.SET_MARKET_MESSAGES_PAGES_COUNT] (state, count) {
      state.marketMessagesArg.pagesCount = count
    },
    [mutationTypes.SET_UNSEEN_MESSAGES_NUMBER] (state, number) {
      state.unseenMessagesNumber = number
    },
    [mutationTypes.SET_PENDING_BOOKING_REQUESTS] (state, number) {
      state.pendingBookingRequests = number
    },
    [mutationTypes.DELETE_MARKET_MESSAGE](state, id) {
      const oldObjectIndex = state.marketMessages.findIndex(
        obj => obj.id === id
      )
      if (oldObjectIndex >= 0)
        state.marketMessages.splice(oldObjectIndex, 1)
    },
    [mutationTypes.UPDATE_MARKET_MESSAGES](state, idList) {
      state.marketMessages = state.marketMessages.filter(obj => !idList.includes(obj.id))
    },
    [mutationTypes.UPDATE_MARKET_MESSAGE](state, { id, marketMessage }) {
      const oldObj = state.marketMessages.find(obj => obj.id === id)
      if (oldObj)
        Object.assign(oldObj, marketMessage)
    },
    [mutationTypes.DELETE_MARKET_MESSAGES](state, idList) {
      state.marketMessages = state.marketMessages.filter(obj => !idList.includes(obj.id))
    },
    [mutationTypes.SET_ADMIN_NAV_ITEMS](state) {
      state.adminNavItems = [
        {
          href: { name: 'customers' },
          text: i18n.t('navigation.admin.customers')
        },
        {
          href: { name: 'payments' },
          text: i18n.t('navigation.admin.payments')
        },
        {
          href: { name: 'market-settings' },
          text: i18n.t('navigation.admin.market_settings')
        },
        {
          href: { name: 'reports' },
          text: i18n.t('navigation.admin.reports')
        },
        {
          href: { name: 'messages' },
          text: i18n.t('navigation.admin.messages'),
          badge: true,
          badgeVariant: 'danger',
          badgeText: state.unseenMessagesNumber
        },
        {
          href: '#',
          text: i18n.t('navigation.general.logout')
        }
      ]

      const token = getToken('AdminToken')
      if (token && token.onlineBookingFeature && token.elavonApiValid) {
        state.adminNavItems.splice(2, 0, {
          href: { name: 'booking' },
          text: i18n.t('navigation.admin.booking'),
          badge: true,
          badgeVariant: 'danger',
          badgeText: state.pendingBookingRequests
        })
      } else {
        state.adminNavItems.splice(2, 0, {
          href: { name: 'booking' },
          text: i18n.t('navigation.admin.booking'),
        })
      }
      if (token && token.isFlealoverSoloFeature) {
        state.adminNavItems.splice(2, 0, {
          href: { name: 'solo-products' },
          text: i18n.t('navigation.admin.solo_products'),
        })
        state.adminNavItems.splice(0, 0, {
          href: { name: 'register-sale' },
          text: i18n.t('navigation.admin.register_sale'),
        })
      }
    },
    [mutationTypes.SET_BOOKINGS_REPORT](state, bookings) {
      state.bookingsReport = bookings
    },
    [mutationTypes.SET_BOOKINGS_REPORT_FILTERS] (state, filters) {
      state.bookingsReportArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_CAMPAIGN_REPORT](state, reports) {
      state.customerCampaignsReport = reports
    },
    [mutationTypes.SET_CUSTOMER_CAMPAIGN_REPORT_FILTERS](state, filters) {
      state.customerCampaignsReportArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_CAMPAIGN_REPORT_PAGE] (state, page) {
      state.customerCampaignsReportArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_CAMPAIGN_REPORT_PAGES_COUNT] (state, count) {
      state.customerCampaignsReportArg.pagesCount = count
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SALES_TOTALS](state, totals) {
      state.customerProductSalesTotals = totals
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SALES](state, sales) {
      state.customerProductSales = sales
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SALES_FILTERS](state, filters) {
      state.customerProductSalesArg.filters = filters
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SALES_PAGE] (state, page) {
      state.customerProductSalesArg.page = page
    },
    [mutationTypes.SET_CUSTOMER_PRODUCT_SALES_PAGES_COUNT] (state, count) {
      state.customerProductSalesArg.pagesCount = count
    },
    [mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS](state, data) {
      state.customerBookingTransactions = data
    },

    [mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS_TOTALS](state, data) {
      state.customerBookingTransactionsTotals = data
    },

    [mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS_PAGE](state, page) {
      state.customerBookingTransactionsArg.page = page
    },

    [mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS_PAGES_COUNT](state, count) {
      state.customerBookingTransactionsArg.pagesCount = count
    },

    [mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS_FILTERS](state, filters) {
      state.customerBookingTransactionsArg.filters = filters
    },
    [mutationTypes.APPEND_CUSTOMER_SUBACCOUNT](state, { parentUserNumber, subaccount }) {
      const parentCustomer = state.customerList.find(customer => customer.userNumber === parentUserNumber)
      if (parentCustomer) {
        parentCustomer.subaccounts.push(subaccount)
      }
    },

    [mutationTypes.SET_CUSTOMER_BALANCE_REPORT_LIST](state, data) {
      state.customerBalanceReportList = data
    },

    [mutationTypes.SET_CUSTOMER_BALANCE_REPORT_PAGE](state, page) {
      state.customerBalanceReportArg.page = page
    },

    [mutationTypes.SET_CUSTOMER_BALANCE_REPORT_PAGES_COUNT](state, count) {
      state.customerBalanceReportArg.pagesCount = count
    },

    [mutationTypes.SET_CUSTOMER_BALANCE_REPORT_TOTAL_BALANCE](state, total) {
      state.customerBalanceReportArg.totalBalance = total
    },

    [mutationTypes.SET_CUSTOMER_BALANCE_REPORT_FILTERS](state, filters) {
      state.customerBalanceReportArg.filters = filters
    },

    [mutationTypes.SET_MANUAL_TRANSACTIONS_REPORT](state, data) {
      state.manualTransactionsReport = data
    },

    [mutationTypes.SET_MANUAL_TRANSACTIONS_REPORT_PAGE](state, page) {
      state.manualTransactionsReportArg.page = page
    },

    [mutationTypes.SET_MANUAL_TRANSACTIONS_REPORT_PAGES_COUNT](state, count) {
      state.manualTransactionsReportArg.pagesCount = count
    },

    [mutationTypes.SET_MANUAL_TRANSACTIONS_REPORT_FILTERS](state, filters) {
      state.manualTransactionsReportArg.filters = filters
    },
  },
  actions: {
    ...baseActions,

    [actionTypes.GET_ADMIN_MARKET]({ state, commit }) {
      return new Promise((resolve, reject) => {
        getAdminMarket({
          url: `${state.marketId}/`
        })
          .then(response => {
            commit(mutationTypes.SET_ADMIN_MARKET, response.data)
            commit(mutationTypes.SET_UNSEEN_MESSAGES_NUMBER, response.data.unseenMessagesNumber)
            commit(mutationTypes.SET_PENDING_BOOKING_REQUESTS, response.data.pendingBookingRequests)
            const token = getToken('AdminToken')
            if (token) {
              token.individualizedItemsAccess = response.data.individualizedItemsAccess
              token.zettleIntegration = response.data.zettleIntegration
              token.isFlealoverSoloFeature = response.data.isFlealoverSoloFeature
              token.paymentsFeature = response.data.paymentsFeature
              token.accountBalanceFeature = response.data.accountBalanceFeature
              token.onlineBookingFeature = response.data.onlineBookingFeature
              token.subaccountFeature = response.data.subaccountFeature
              token.elavonApiValid = response.data.elavonApiValid
              setToken(token)
            }
            commit(mutationTypes.SET_ADMIN_NAV_ITEMS)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_ADMIN_DATA]({ commit }) {
      return new Promise((resolve, reject) => {
        getAdmin()
          .then((response) => {
            commit(mutationTypes.SET_USER_DATA, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.CHANGE_ADMIN_DATA] ({commit}, payloads) {
      return new Promise((resolve, reject) => {
        updateAdmin({
          data: payloads
        })
          .then((response) => {
            const token = getToken('AdminToken')
            if (token) {
              token.username = response.data.username
              setToken(token)
              commit(mutationTypes.SET_USER_DATA, response.data)
            } else {
              commit(mutationTypes.LOGOUT_ADMIN)
            }
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.LOGOUT_ADMIN]({ commit }, url) {
      return new Promise((resolve, reject) => {
        const token = getToken('AdminToken')
        if (!token || !token.accessToken) {
          commit(mutationTypes.LOGOUT_ADMIN)
        }
        revokeToken({
          data: {'token': token.accessToken}
        })
          .then(response => {
            commit(mutationTypes.LOGOUT_ADMIN, url)
            resolve(response)
          })
          .catch(error => {
            commit(mutationTypes.LOGOUT_ADMIN)
            reject(error.response)
          })
      })
    },

    [actionTypes.UPDATE_MARKET_SETTINGS]({ state, commit, dispatch }, { payloads, method = 'put' }) {
      return new Promise((resolve, reject) => {
        updateMarketSettings({
          method: method,
          url: `${state.marketId}/`,
          data: payloads
        })
          .then(response => {
            if (payloads.marketId) {
              const token = getToken('AdminToken')
              if (token) {
                if (token.marketId) {
                  token.marketId = response.data.marketId
                  token.flexposApiValid = response.data.flexposApiValid
                  token.zettleIntegration = response.data.zettleIntegration
                  token.isFlealoverSoloFeature = response.data.isFlealoverSoloFeature
                  token.zettleApiValid = response.data.zettleApiValid
                  token.economicApiValid = response.data.economicApiValid
                  token.individualizedItemsAccess = response.data.individualizedItemsAccess
                  token.onlineBookingFeature = response.data.onlineBookingFeature
                  token.subaccountFeature = response.data.subaccountFeature
                  token.elavonApiValid = response.data.elavonApiValid
                  setToken(token)
                  commit(mutationTypes.SET_MARKET_HEADER, token.marketId ? token.marketId : '')
                } else {
                  dispatch(actionTypes.LOGOUT_ADMIN)
                  reject({data: ['No marketId in token']})
                }
              } else {
                commit(mutationTypes.LOGOUT_ADMIN)
                reject({data: ['No token']})
              }
            }
            commit(mutationTypes.SET_MARKET_SETTINGS, response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },

    [actionTypes.UPDATE_MARKET_LOGO]({ state, commit }, formDataLogoFile) {
      return new Promise((resolve, reject) => {
        marketLogo({
          url: `${state.marketId}/`,
          data: formDataLogoFile,
          method: 'put'
        })
          .then(response => {
            commit(mutationTypes.UPDATE_MARKET_LOGO, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.DELETE_MARKET_LOGO]({ state, commit }) {
      return new Promise((resolve, reject) => {
        marketLogo({
          url: `${state.marketId}/`,
          method: 'delete'
        })
          .then(response => {
            commit(mutationTypes.DELETE_MARKET_LOGO)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.CREATE_MARKET_IMAGE]({ commit }, imageFile) {
      return new Promise((resolve, reject) => {
        createMarketImage({
          data: imageFile
        })
          .then(response => {
            commit(mutationTypes.APPEND_MARKET_IMAGE, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.DELETE_MARKET_IMAGE]({ commit }, imageId) {
      return new Promise((resolve, reject) => {
        deleteMarketImage({
          url: `${imageId}/`,
        })
          .then(response => {
            commit(mutationTypes.DELETE_MARKET_IMAGE, imageId)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCustomerList({
          params: {
            page: state.customerArg.page,
            ...state.customerArg.filters
          }
        })
          .then(response => {
            if (response.data.results)
              commit(mutationTypes.SET_CUSTOMER_LIST, response.data.results)
            else
              commit(mutationTypes.SET_CUSTOMER_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_ALL_CUSTOMERS]({ commit }) {
      return new Promise((resolve, reject) => {
        getAllCustomers()
          .then(response => {
            commit(mutationTypes.SET_ALL_CUSTOMERS, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_CUSTOMER]({ commit }, userNumber) {
      return new Promise((resolve, reject) => {
        getCustomer({
          url: `${userNumber}/`
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_CUSTOMER]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addCustomer({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_CUSTOMER, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_CUSTOMER]({ commit }, { payloads, userNumber, method = 'put' }) {
      return new Promise((resolve, reject) => {
        editCustomer({
          method: method,
          url: userNumber + '/',
          data: payloads
        })
          .then(response => {
            if (response.data.isSubaccount) {
              commit(mutationTypes.UPDATE_CUSTOMER_SUBACCOUNT, response.data)
            } else {
              commit(mutationTypes.UPDATE_CUSTOMER, { oldUserNumber: userNumber, customer: response.data })
              if (method === 'patch') {
                commit(mutationTypes.SET_CUSTOMER, response.data)
              }
            }
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_CUSTOMER]({ commit }, userNumber) {
      return new Promise((resolve, reject) => {
        deleteCustomer({
          url: userNumber + '/'
        })
          .then(response => {
            commit(mutationTypes.DELETE_CUSTOMER, userNumber)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    [actionTypes.SEND_EMAIL_CONFIRMATION]({ commit }, email) {
      return new Promise((resolve, reject) => {
        sendEmailConfirmation({
          url: `${email}/`
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.VERIFY_CUSTOMER]({ commit }, userNumber) {
      return new Promise((resolve, reject) => {
        verifyCustomer({
          url: userNumber + '/',
        })
          .then(response => {
            commit(mutationTypes.VERIFY_CUSTOMER, { userNumber: userNumber, verified: response.data.verified })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    [actionTypes.RESET_CUSTOMER_PASSWORD]({ commit }, userNumber) {
      return new Promise((resolve, reject) => {
        resetCustomerPassword({
          url: userNumber + '/',
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_PAYMENTS_INFO]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getPaymentsInfo({
          params: state.paymentsInfoArg.filters
        })
          .then(response => {
            commit(mutationTypes.SET_PAYMENTS_INFO, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_FINALIZED_SAVED_PERIODS]({ commit }) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'get',
          url: 'finalized/'
        })
          .then(response => {
            commit(mutationTypes.SET_FINALIZED_SAVED_PERIODS, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    [actionTypes.DOWNLOAD_TOTAL_PAYMENT_REPORT_PDF]({ commit }, id) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'post',
          url: `${id}/download_pdf/`,
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_SAVED_PERIODS]({ commit }) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'get',
        })
          .then(response => {
            commit(mutationTypes.SET_SAVED_PERIODS, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.SAVE_PAYMENTS_DATES]({ state }, paymentsDates) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'post',
          params: state.saveType,
          data: paymentsDates
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_SAVED_PERIOD]({ commit }, id) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'delete',
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_SAVED_PERIOD, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EXPORT_SALES_PERIOD_TO_ECONOMIC]({ commit }, id) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'post',
          url: `${id}/economic_export/`
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SALES_PERIOD, { id: id, period: response.data })
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.SEND_PAYMENT_TO_CUSTOMERS]({ commit }, id) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'post',
          url: `${id}/send_to_customers/`
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SALES_PERIOD, { id: id, period: response.data })
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.RESET_SALES_PERIOD]({ commit }, id) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'patch',
          url: `${id}/reset/`
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SALES_PERIOD, { id: id, period: response.data })
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.FINALIZE_SALES_PERIOD]({ commit }, id) {
      return new Promise((resolve, reject) => {
        salesPeriods({
          method: 'patch',
          url: `${id}/finalize/`
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SALES_PERIOD, { id: id, period: response.data })
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_PAYMENT_REPORTS]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCustomerPaymentReports({
          params: {
            page: state.customerPaymentReportsArg.page,
            ...state.customerPaymentReportsArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PAYMENT_REPORTS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    [actionTypes.SEND_PAYMENT_REPORT_TO_CUSTOMER]({ commit }, id) {
      return new Promise((resolve, reject) => {
        getCustomerPaymentReports({
          method: 'post',
          url: `${id}/send_to_customer/`
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    [actionTypes.DOWNLOAD_CUSTOMER_PAYMENT_REPORT_PDF]({ commit }, id) {
      return new Promise((resolve, reject) => {
        getCustomerPaymentReports({
          method: 'post',
          url: `${id}/download_pdf/`,
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_SHELF_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getShelfList({
          params: {
            page: state.shelfArg.page,
            ...state.shelfArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_SHELF_LIST, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_SHELF]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addShelf({
          data: payloads
        })
          .then(response => {
            // If admin created many shelves (array response) -
            // append all of them to current list
            // If only one shelf (object response) - append only one then
            if (Array.isArray(response.data)) {
              for (const shelf of response.data) {
                if (Object.keys(shelf).length)
                  commit(mutationTypes.APPEND_SHELF, shelf)
              }
            } else {
              if (Object.keys(response.data).length)
                commit(mutationTypes.APPEND_SHELF, response.data)
            }
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_SHELF]({ commit }, { payloads, id }) {
      return new Promise((resolve, reject) => {
        editShelf({
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SHELF, { id: id, shelf: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_SHELF]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteShelf({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_SHELF, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.UPDATE_MARKET_CLOSING_DAYS]({ state, commit }, payloads) {
      return new Promise((resolve, reject) => {
        updateMarketClosingDays({
          url: `${state.marketId}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.SET_MARKET_CLOSING_DAYS, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_SHELF_PERIOD_PRICE_LIST]({ commit }) {
      return new Promise((resolve, reject) => {
        getShelfPeriodPriceList()
          .then(response => {
            commit(mutationTypes.SET_SHELF_PERIOD_PRICE_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.UPDATE_SHELF_PERIOD_PRICE]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        updateShelfPeriodPrice({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.SET_SHELF_PERIOD_PRICE_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST]({ commit }) {
      return new Promise((resolve, reject) => {
        getShelfTypeServiceList()
          .then(response => {
            commit(mutationTypes.SET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.UPDATE_SHELF_TYPE_ADDITIONAL_SERVICE]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        updateShelfTypeService({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.SET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_BOOKING_PERIOD_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getBookingPeriodList({
          params: {
            ...state.bookingPeriodArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_BOOKING_PERIOD_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_BOOKING_PERIOD]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addBookingPeriod({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_BOOKING_PERIOD, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_BOOKING_PERIOD]({ commit }, { payloads, id }) {
      return new Promise((resolve, reject) => {
        editBookingPeriod({
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_BOOKING_PERIOD, { id: id, period: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_BOOKING_PERIOD]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteBookingPeriod({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_BOOKING_PERIOD, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_ADDITIONAL_SERVICE_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getAdditionalServiceList({
          params: {
            ...state.additionalServiceArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_ADDITIONAL_SERVICE_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_ADDITIONAL_SERVICE]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addAdditionalService({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_ADDITIONAL_SERVICE, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_ADDITIONAL_SERVICE]({ commit }, { payloads, id }) {
      return new Promise((resolve, reject) => {
        editAdditionalService({
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_ADDITIONAL_SERVICE, { id: id, service: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_ADDITIONAL_SERVICE]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteAdditionalService({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_ADDITIONAL_SERVICE, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_SHELF_TYPE_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getShelfTypeList({
          params: {
            page: state.shelfTypeArg.page,
            ...state.shelfTypeArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_SHELF_TYPE_LIST, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_SHELF_TYPE]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addShelfType({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_SHELF_TYPE, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_SHELF_TYPE]({ commit }, { payloads, id }) {
      return new Promise((resolve, reject) => {
        editShelfType({
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SHELF_TYPE, { id: id, type: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_SHELF_TYPE]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteShelfType({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_SHELF_TYPE, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_CUSTOMER_BOOKING_REQUESTS]({ commit, state }) {
      return new Promise((resolve, reject) => {
        bookingRequests({
          params: {
            page: state.bookingRequestArg.page,
            ...state.bookingRequestArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BOOKING_REQUESTS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.CONFIRM_BOOKING_REQUEST]({ state, commit }, { id, payload }) {
      return new Promise((resolve, reject) => {
        bookingRequests({
          method: 'put',
          url: `${id}/confirm/`,
          data: payload,
        })
          .then(response => {
            commit(mutationTypes.SET_SHELF_BOOKING_METADATA, {})
            commit(mutationTypes.SET_PENDING_BOOKING_REQUESTS, state.pendingBookingRequests ? state.pendingBookingRequests - 1 : 0)
            commit(mutationTypes.SET_ADMIN_NAV_ITEMS)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.REFUND_BOOKING_REQUEST]({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        bookingRequests({
          method: 'post',
          url: `${payload.id}/refund/`,
          data: payload,
        })
          .then(response => {
            commit(mutationTypes.SET_SHELF_BOOKING_METADATA, {})
            commit(mutationTypes.SET_PENDING_BOOKING_REQUESTS, state.pendingBookingRequests ? state.pendingBookingRequests - 1 : 0)
            commit(mutationTypes.SET_ADMIN_NAV_ITEMS)
            commit(mutationTypes.UPDATE_BOOKING_REQUEST, { id: payload.id, status: BOOKING_REFUND_INITIATED, addonsRefunded: response.data.addonsRefunded })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.UPDATE_BOOKING_REQUEST_MARKET_DATES]({ commit }, { id, payloads }) {
      return new Promise((resolve, reject) => {
        bookingRequests({
          method: 'put',
          data: payloads,
          url: `${id}/update_booking_market_dates/`,
        })
          .then(response => {
            commit(mutationTypes.UPDATE_BOOKING_REQUEST, { id: id, request: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    [actionTypes.RESEND_BOOKING_PAYMENT_REQUEST_EMAIL]({ commit }, id) {
      return new Promise((resolve, reject) => {
        addShelfBooking({
          url: `${id}/send_payment_request_email/`,
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CAMPAIGN_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCampaignList({
          params: {
            page: state.campaignArg.page,
            ...state.campaignArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CAMPAIGN_LIST, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_CAMPAIGN]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addCampaign({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_CAMPAIGN, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_CAMPAIGN]({ commit }, { payloads, id }) {
      return new Promise((resolve, reject) => {
        editCampaign({
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_CAMPAIGN, { id: id, campaign: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_CAMPAIGN]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteCampaign({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_CAMPAIGN, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_SHELF_BOOKING_LIST]({ commit, state }, filters) {
      commit(mutationTypes.SET_SHELF_BOOKING_FILTERS, filters)
      return new Promise((resolve, reject) => {
        getShelfBookingList({
          params: state.shelfBookingArg.filters
        })
          .then(response => {
            if (response.data.results) {
              commit(mutationTypes.SET_SHELF_BOOKING_LIST, response.data.results)
              commit(mutationTypes.SET_SHELF_BOOKING_METADATA, response.data)
            } else {
              commit(mutationTypes.SET_SHELF_BOOKING_LIST, response.data)
              commit(mutationTypes.SET_SHELF_BOOKING_METADATA, {})
            }
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_SHELF_BOOKING]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addShelfBooking({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_SHELF_BOOKING, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_SHELF_BOOKING]({ commit }, { payloads, id }) {
      return new Promise((resolve, reject) => {
        editShelfBooking({
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SHELF_BOOKING, { id: id, shelfBooking: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_SHELF_BOOKING]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteShelfBooking({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_SHELF_BOOKING, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_BOOKINGS]({ commit, state }, userNumber) {
      return new Promise((resolve, reject) => {
        getCustomerBookings({
          url: `${userNumber}/`,
          params: {
            page: state.customerBookingArg.page,
            ...state.customerBookingArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BOOKINGS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_PRODUCT_SHEETS]({ commit, state }, userNumber) {
      return new Promise((resolve, reject) => {
        customerProductSheets({
          url: `${userNumber}/`,
          params: {
            page: state.customerProductSheetsArg.page,
            ...state.customerProductSheetsArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_SHEETS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_CUSTOMER_PRODUCT_SHEET]({ commit }, {userNumber, id}) {
      return new Promise((resolve, reject) => {
        customerProductSheets({
          url: `${userNumber}/${id}/`
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_SHEET, response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.CREATE_CUSTOMER_PRODUCT_SHEET]({ commit }, {userNumber, payloads}) {
      return new Promise((resolve, reject) => {
        createCustomerProductSheet({
          url: `${userNumber}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_CUSTOMER_PRODUCT_SHEET, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.UPDATE_CUSTOMER_PRODUCT_SHEET]({ commit }, { userNumber, payloads, id }) {
      return new Promise((resolve, reject) => {
        updateCustomerProductSheet({
          url: `${userNumber}/${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_SHEET, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.COMPLETE_CUSTOMER_PRODUCT_SHEET]({ commit }, {userNumber, id}) {
      return new Promise((resolve, reject) => {
        customerProductSheets({
          method: 'patch',
          url: `${userNumber}/${id}/complete/`
        })
          .then(response => {
            commit(mutationTypes.UPDATE_CUSTOMER_PRODUCT_SHEET, { id: id, sheet: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_CUSTOMER_PRODUCT_SHEET]({ commit }, { userNumber, id }) {
      return new Promise((resolve, reject) => {
        deleteCustomerProductSheet({
          url: `${userNumber}/${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_CUSTOMER_PRODUCT_SHEET, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_BALANCE_TRANSACTIONS]({ commit, state }, userNumber) {
      return new Promise((resolve, reject) => {
        balanceTransactions({
          method: 'get',
          url: `${userNumber}/`,
          params: {
            page: state.customerBalanceTransactionsArg.page,
            ...state.customerBalanceTransactionsArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.CREATE_CUSTOMER_BALANCE_TRANSACTION]({ state, commit }, { userNumber, payloads }) {
      return new Promise((resolve, reject) => {
        balanceTransactions({
          method: 'post',
          url: `${userNumber}/`,
          data: { ...payloads, page: state.customerBalanceTransactionsArg.page },
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.UPDATE_CUSTOMER_BALANCE_TRANSACTION]({ state, commit }, { userNumber, payloads, id }) {
      return new Promise((resolve, reject) => {
        balanceTransactions({
          method: 'patch',
          url: `${userNumber}/${id}/`,
          data: { ...payloads, page: state.customerBalanceTransactionsArg.page },
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BALANCE_TRANSACTIONS, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_CUSTOMER_BALANCE_TRANSACTION]({ commit }, { userNumber, id }) {
      return new Promise((resolve, reject) => {
        balanceTransactions({
          method: 'delete',
          url: `${userNumber}/${id}/`
        })
          .then(response => {
            commit(mutationTypes.REMOVE_UPDATE_CUSTOMER_BALANCE_TRANSACTIONS, id)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_PRODUCT_SALE_LINE_LIST]({ commit }, id) {
      return new Promise((resolve, reject) => {
        getCustomerProductSaleLines({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_SALE_LINE_LIST, response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_PRODUCT_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCustomerProducts({
          params: {
            page: state.customerProductsArg.page,
            ...state.customerProductsArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_LIST, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.CHECKOUT_CUSTOMER_PRODUCT]({ commit }, productId) {
      return new Promise((resolve, reject) => {
        productsUpdate({
          url: `${productId}/checkout/`,
        })
          .then(response => {
            commit(mutationTypes.UPDATE_CUSTOMER_PRODUCT, { id: productId, product: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.REVERT_CUSTOMER_PRODUCT_CHECKOUT]({ commit }, productId) {
      return new Promise((resolve, reject) => {
        productsUpdate({
          url: `${productId}/revert_checkout/`,
        })
          .then(response => {
            commit(mutationTypes.UPDATE_CUSTOMER_PRODUCT, { id: productId, product: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    [actionTypes.UPDATE_CUSTOMER_PRODUCT]({ commit }, { productId, payloads }) {
      return new Promise((resolve, reject) => {
        productsUpdate({
          url: `${productId}/update_product/`,
          data: payloads,
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.CREATE_CUSTOMER_PRODUCTS]({ commit }, { productSheetId, userNumber, products }) {
      return new Promise((resolve, reject) => {
        createCustomerProduct({
          url: `${productSheetId}/products/${userNumber}/`,
          data: products
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.PRINT_CUSTOMER_PRODUCT_SHEET]({ commit }, {userNumber, id}) {
      return new Promise((resolve, reject) => {
        customerProductSheets({
          method: 'patch',
          url: `${userNumber}/${id}/print/`
        })
          .then(response => {
            commit(mutationTypes.UPDATE_CUSTOMER_PRODUCT_SHEET, { id: id, sheet: response.data })
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    [actionTypes.ADD_PRODUCTS_TO_CAMPAIGN]({ commit, state }, {userNumber, id}) {
      return new Promise((resolve, reject) => {
        productCampaigns({
          method: 'post',
          url: `${userNumber}/${id}/add_products/`
        })
          .then(response => {
            if (state.adminMarket && state.adminMarket.isFlealoverSoloFeature) {
              commit(mutationTypes.UPDATE_CUSTOMER, {
                oldUserNumber: userNumber,
                customer: { productsInCampaign: true }
              })
            }
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.REMOVE_PRODUCTS_FROM_CAMPAIGN]({ commit, state }, userNumber) {
      return new Promise((resolve, reject) => {
        productCampaigns({
          method: 'post',
          url: `${userNumber}/remove_products/`
        })
          .then(response => {
            if (state.adminMarket && state.adminMarket.isFlealoverSoloFeature) {
              commit(mutationTypes.UPDATE_CUSTOMER, {
                oldUserNumber: userNumber,
                customer: { productsInCampaign: false }
              })
            }
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_BANK_EXPORT_TRANSACTIONS]({ state, commit }) {
      return new Promise((resolve, reject) => {
        bankExportTransactions({
          params: state.bankExportTransactionsArg.filters,
        })
          .then(response => {
            commit(mutationTypes.SET_BANK_EXPORT_TRANSACTIONS, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_BANK_EXPORT_TRANSACTION]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        bankExportTransactions({
          method: 'patch',
          url: `${payloads.id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_BANK_EXPORT_TRANSACTION, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_BANK_EXPORT_TRANSACTION]({ commit }, id) {
      return new Promise((resolve, reject) => {
        bankExportTransactions({
          method: 'delete',
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_BANK_EXPORT_TRANSACTION, id)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_ECONOMIC_LAYOUTS]({ commit }) {
      return new Promise((resolve, reject) => {
        economicLayouts()
          .then(response => {
            commit(mutationTypes.SET_ECONOMIC_LAYOUTS, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_MARKET_MESSAGES]({ state, commit }) {
      return new Promise((resolve, reject) => {
        marketMessages({
          params: {
            ...state.marketMessagesArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_MARKET_MESSAGES, response.data.results)
            commit(mutationTypes.SET_UNSEEN_MESSAGES_NUMBER, 0)
            commit(mutationTypes.SET_ADMIN_NAV_ITEMS)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.DELETE_MARKET_MESSAGE]({ commit }, id) {
      return new Promise((resolve, reject) => {
        marketMessages({
          method: 'delete',
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_MARKET_MESSAGE, id)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.DELETE_MARKET_MESSAGES]({ commit }, idList) {
      return new Promise((resolve, reject) => {
        marketMessages({
          method: 'delete',
          url: 'delete_selected/',
          data: {
            ids: idList
          },
        })
          .then(response => {
            commit(mutationTypes.DELETE_MARKET_MESSAGES, idList)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.UPDATE_MARKET_MESSAGE]({ state, commit }, { id, ...payloads }) {
      return new Promise((resolve, reject) => {
        marketMessages({
          method: 'patch',
          url: `${id}/`,
          data: payloads,
        })
          .then(response => {
            const oldObj = state.marketMessages.find(obj => obj.id === id)
            if (oldObj && oldObj.archived !== response.data.archived) {
              commit(mutationTypes.DELETE_MARKET_MESSAGE, id)
            } else {
              commit(mutationTypes.UPDATE_MARKET_MESSAGE, {
                id: id,
                marketMessage: response.data,
              })
            }
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.UPDATE_MARKET_MESSAGES]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        marketMessages({
          method: 'patch',
          url: 'update_selected/',
          data: payloads,
        })
          .then(response => {
            commit(mutationTypes.UPDATE_MARKET_MESSAGES, payloads.ids)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_BOOKINGS_REPORT]({ state, commit }) {
      return new Promise((resolve, reject) => {
        bookingsReport({
          params: {
            ...state.bookingsReportArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_BOOKINGS_REPORT, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.EXPORT_CUSTOMER_PRODUCT_SALES_REPORT]({ state }) {
      return new Promise((resolve, reject) => {
        getCustomerProductSalesReport({
          url: 'export_pdf/',
          params: {
            ...state.customerProductSalesArg.filters
          },
          responseType: 'blob'
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_CUSTOMER_PRODUCT_SALES]({ state, commit }) {
      return new Promise((resolve, reject) => {
        getCustomerProductSalesReport({
          params: {
            page: state.customerProductSalesArg.page,
            ...state.customerProductSalesArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_SALES, response.data.results)
            commit(mutationTypes.SET_CUSTOMER_PRODUCT_SALES_TOTALS, response.data.totals)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_BOOKING_TRANSACTION_REPORT]({ state, commit }) {
      return new Promise((resolve, reject) => {
        getBookingTransactionReport({
          params: {
            page: state.customerBookingTransactionsArg.page,
            ...state.customerBookingTransactionsArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS, response.data.results)
            commit(mutationTypes.SET_CUSTOMER_BOOKING_TRANSACTIONS_TOTALS, response.data.totals)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EXPORT_BOOKING_TRANSACTION_REPORT]({ state }) {
      return new Promise((resolve, reject) => {
        getBookingTransactionReport({
          url: 'export_pdf/',
          params: {
            ...state.customerBookingTransactionsArg.filters
          },
          responseType: 'blob'
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_CAMPAIGN_REPORT]({ state, commit }) {
      return new Promise((resolve, reject) => {
        customerCampaignsReport({
          params: {
            page: state.customerCampaignsReportArg.page,
            ...state.customerCampaignsReportArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_CAMPAIGN_REPORT, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.ADD_USER_PRODUCT_TO_CAMPAIGN]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        marketMessages({
          method: 'patch',
          url: 'update_selected/',
          data: payloads,
        })
          .then(response => {
            commit(mutationTypes.UPDATE_MARKET_MESSAGES, payloads.ids)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.CREATE_CUSTOMER_SUBACCOUNT]({ commit }, userNumber) {
      return new Promise((resolve, reject) => {
        customerSubaccounts({
          method: 'post',
          url: `${userNumber}/create_subaccount/`
        })
          .then(response => {
            commit(mutationTypes.APPEND_CUSTOMER_SUBACCOUNT, { parentUserNumber: userNumber, subaccount: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_CUSTOMER_BALANCE_REPORT]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCustomerBalanceReport({
          params: {
            page: state.customerBalanceReportArg.page,
            ...state.customerBalanceReportArg.filters,
          },
        })
          .then(response => {
            commit(mutationTypes.SET_CUSTOMER_BALANCE_REPORT_LIST, response.data.results || response.data)
            if (response.data.totalBalance !== undefined) {
              commit(mutationTypes.SET_CUSTOMER_BALANCE_REPORT_TOTAL_BALANCE, response.data.totalBalance)
            }
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.EXPORT_CUSTOMER_BALANCE_REPORT_PDF]({ state }) {
      return new Promise((resolve, reject) => {
        exportCustomerBalanceReportPdf({
          params: {
            ...state.customerBalanceReportArg.filters,
          },
          responseType: 'blob',
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.EXPORT_CUSTOMER_BALANCE_REPORT_XLSX]({ state }) {
      return new Promise((resolve, reject) => {
        exportCustomerBalanceReportXlsx({
          params: {
            ...state.customerBalanceReportArg.filters,
          },
          responseType: 'blob',
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_MANUAL_TRANSACTIONS_REPORT]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getManualTransactionsReport({
          params: {
            page: state.manualTransactionsReportArg.page,
            ...state.manualTransactionsReportArg.filters,
          },
        })
          .then(response => {
            commit(mutationTypes.SET_MANUAL_TRANSACTIONS_REPORT, response.data.results || response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.EXPORT_MANUAL_TRANSACTIONS_REPORT_PDF]({ state }) {
      return new Promise((resolve, reject) => {
        getManualTransactionsReport({
          url: 'export_pdf/',
          params: {
            ...state.manualTransactionsReportArg.filters,
          },
          responseType: 'blob',
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.EXPORT_MANUAL_TRANSACTIONS_REPORT_XLSX]({ state }) {
      return new Promise((resolve, reject) => {
        getManualTransactionsReport({
          url: 'export_xlsx/',
          params: {
            ...state.manualTransactionsReportArg.filters,
          },
          responseType: 'blob',
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.DOWNLOAD_CASH_PAYOUT_SLIP](_, { userNumber, transactionId }) {
      return new Promise((resolve, reject) => {
        balanceTransactions({
          method: 'get',
          url: `${userNumber}/${transactionId}/cash_payout_slip/`,
          responseType: 'blob',
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },

    [actionTypes.GET_SOLO_PRODUCT_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getSoloProductList({
          params: {
            page: state.soloProductArg.page,
            ...state.soloProductArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_SOLO_PRODUCT_LIST, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.ADD_SOLO_PRODUCT]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addSoloProduct({
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.APPEND_SOLO_PRODUCT, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.EDIT_SOLO_PRODUCT]({ commit }, { payloads, id, method = 'put' }) {
      return new Promise((resolve, reject) => {
        editSoloProduct({
          method: method,
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SOLO_PRODUCT, { id: id, product: response.data })
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DELETE_SOLO_PRODUCT]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteSoloProduct({
          url: `${id}/`
        })
          .then(response => {
            commit(mutationTypes.DELETE_SOLO_PRODUCT, id)
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.REORDER_SOLO_PRODUCTS](_, { categoryId, orderedIds }) {
      return new Promise((resolve, reject) => {
        reorderSoloProducts({
          data: { categoryId: categoryId, orderedIds: orderedIds }
        })
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.GET_SOLO_CATEGORY_LIST]({ commit }, params = {}) {
      return new Promise((resolve, reject) => {
        getSoloCategoryList({ params })
          .then(response => {
            commit(mutationTypes.SET_SOLO_CATEGORY_LIST, response.data)
            resolve(response.data)
          })
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.ADD_SOLO_CATEGORY]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        addSoloCategory({ data: payloads })
          .then(response => {
            commit(mutationTypes.APPEND_SOLO_CATEGORY, response.data)
            resolve(response.data)
          })
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.EDIT_SOLO_CATEGORY]({ commit }, { payloads, id, method = 'put' }) {
      return new Promise((resolve, reject) => {
        editSoloCategory({
          method: method,
          url: `${id}/`,
          data: payloads
        })
          .then(response => {
            commit(mutationTypes.UPDATE_SOLO_CATEGORY, { id, category: response.data })
            resolve(response.data)
          })
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.DELETE_SOLO_CATEGORY]({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteSoloCategory({ url: `${id}/` })
          .then(response => {
            commit(mutationTypes.DELETE_SOLO_CATEGORY, id)
            resolve(response)
          })
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.REORDER_SOLO_CATEGORIES](_, orderedIds) {
      return new Promise((resolve, reject) => {
        reorderSoloCategories({ data: { orderedIds: orderedIds } })
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
      })
    },

    [actionTypes.GET_SOLO_SALE_LIST]({ commit, state }) {
      return new Promise((resolve, reject) => {
        getSoloSaleList({
          params: {
            page: state.soloSaleArg.page,
            ...state.soloSaleArg.filters
          }
        })
          .then(response => {
            commit(mutationTypes.SET_SOLO_SALE_LIST, response.data.results)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.GET_SOLO_SALE]({ commit }, id) {
      return new Promise((resolve, reject) => {
        getSoloSale({
          url: `${id}/`,
        })
          .then(response => {
            commit(mutationTypes.SET_SELECTED_SOLO_SALE, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.CREATE_SOLO_SALE]({ commit }, payloads) {
      return new Promise((resolve, reject) => {
        createSoloSale({
          data: payloads,
        })
          .then(response => {
            commit(mutationTypes.APPEND_SOLO_SALE, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.REFUND_SOLO_SALE]({ commit }, { id, payloads }) {
      return new Promise((resolve, reject) => {
        refundSoloSale({
          url: `${id}/refund/`,
          data: payloads,
        })
          .then(response => {
            commit(mutationTypes.APPEND_SOLO_SALE, response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.LOOKUP_SOLO_PRODUCT](_, params) {
      // Accepts a bare query string OR a params dict.
      const queryParams = typeof params === 'string' ? { q: params } : params
      return new Promise((resolve, reject) => {
        lookupSoloProduct({ params: queryParams })
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.GET_ACTIVE_PRODUCT_SHEETS](_, userNumber) {
      return new Promise((resolve, reject) => {
        customerProductSheets({
          url: `${userNumber}/`,
          params: { has_products: true },
        })
          .then(response => resolve(response.data))
          .catch(error => reject(error.response))
      })
    },
    [actionTypes.EMAIL_SOLO_RECEIPT](_, { id, email }) {
      return new Promise((resolve, reject) => {
        emailSoloReceipt({
          url: `${id}/email_receipt/`,
          data: { email },
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DOWNLOAD_SOLO_RECEIPT_PDF](_, id) {
      return new Promise((resolve, reject) => {
        downloadSoloReceiptPdf({
          url: `${id}/receipt_pdf/`,
          responseType: 'blob',
        })
          .then(response => { resolve(response) })
          .catch(error => { reject(error.response) })
      })
    },
    [actionTypes.GET_SOLO_RECEIPT_HTML](_, id) {
      return new Promise((resolve, reject) => {
        getSoloReceiptHtml({
          url: `${id}/receipt_html/`,
          responseType: 'text',
        })
          .then(response => { resolve(response.data) })
          .catch(error => { reject(error.response) })
      })
    },
    [actionTypes.GET_SOLO_SALE_TOTALS]({ state }) {
      return new Promise((resolve, reject) => {
        getSoloSaleTotals({
          params: { ...state.soloSaleArg.filters }
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
    [actionTypes.DOWNLOAD_SOLO_CSV]({ state }) {
      return new Promise((resolve, reject) => {
        downloadSoloCsv({
          params: { ...state.soloSaleArg.filters },
          responseType: 'blob',
        })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error.response)
          })
      })
    },
  }
})
